import React from "react";
import ChoixChips from "../../common/ChoixChips/ChoixChips";
import { ListPageHeader } from "../../common/DataList";
import usePersistedState from "../../Hooks/usePersistedState/usePersistedState";
import useCalendrierEp from "./useCalendrierEp";
import VueClassiqueEp from "./VueClassiqueEp";
import VueCompacteEp from "./VueCompacteEp";
import "./calendrier-ep.scss";

// ============================================================
// Calendrier des EP, en deux vues au choix de l'agent : la vue compacte
// (nouvelle, par défaut) et la vue classique (l'ancien calendrier, conservé
// à l'identique). Le choix est mémorisé dans le navigateur pour une adoption
// progressive, sans forcer le changement. L'année et les appels sont
// partagés (useCalendrierEp) : basculer ne recharge rien.
// ============================================================

export const CLE_VUE = "espoar.boa.calendrierEp.vue";
export const CLE_BANDEAU_NOUVELLE_VUE = "espoar.boa.calendrierEp.bandeauVu";
export const VUES = [
  { id: "compacte", name: "Nouvelle vue", icon: "th-list" },
  { id: "classique", name: "Vue classique", icon: "columns" },
];

const lireVue = (valeur) => (VUES.some((v) => v.id === valeur) ? valeur : "compacte");

const EPCalendar = () => {
  const calendrier = useCalendrierEp();
  const [vueMemorisee, setVue] = usePersistedState(CLE_VUE, "compacte");
  const [bandeauVu, setBandeauVu] = usePersistedState(CLE_BANDEAU_NOUVELLE_VUE, false);
  const vue = lireVue(vueMemorisee);
  const { errors, maintenant, creerEp } = calendrier;

  return (
    <div className={`container-fluid px-5 my-5 list-page calendrier-ep calendrier-ep--${vue}`}>
      <ListPageHeader
        title="Calendrier des EP"
        subtitle={vue === "compacte" ? "Sessions d'équipe pluridisciplinaire de l'année, par mois." : null}
      >
        <ChoixChips
          name="vue-calendrier"
          legend="Affichage"
          variant="inline"
          size="sm"
          options={VUES}
          value={vue}
          onChange={(v) => {
            setVue(v);
            setBandeauVu(true);
          }}
        />
        {vue === "compacte" && (
          <span data-priv="edit_ep">
            <button type="button" className="btn btn-primary" onClick={() => creerEp(maintenant.month - 1)}>
              <i className="fa fa-plus mr-2" aria-hidden="true" />
              Planifier une EP
            </button>
          </span>
        )}
      </ListPageHeader>

      {vue === "compacte" && !bandeauVu && (
        <div className="cal-bandeau" role="status">
          <i className="fa fa-info-circle" aria-hidden="true" />
          <span>
            <b>Nouvel affichage du calendrier.</b> Toute l'année tient sur un écran ; seuls les états qui
            demandent votre attention portent une pastille. Vous pouvez revenir à la vue classique à tout moment
            avec le sélecteur « Affichage », votre choix est mémorisé.
          </span>
          <button type="button" className="btn btn-sm btn-link" onClick={() => setBandeauVu(true)}>
            J'ai compris
          </button>
        </div>
      )}

      {errors && errors.other && (
        <div className="alert alert-danger" role="alert">
          {errors.other}
        </div>
      )}

      {vue === "compacte" ? <VueCompacteEp calendrier={calendrier} /> : <VueClassiqueEp calendrier={calendrier} />}
    </div>
  );
};

export default EPCalendar;
